const guideList = () => import('@/pages/guide/index.vue');
const guideForm = () => import('@/pages/guide/form.vue');

export default [{
    path: '/guide/list',
    component: guideList,
    meta: [{
        name: 'Guide管理'
    },
    {
        name: 'Guide列表',
        activeRoute: '/guide/list'
    }]
}, {
    path: '/guide/form',
    component: guideForm,
    meta: [{
        name: 'Guide管理'
    },
    {
        name: 'Guide列表',
        url: '/guide/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/guide/list'
    }]
}];